/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/payment.css';
import { Button, Icon, Segment, Form, Container, Header, Checkbox, Popup, Grid, Progress} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import ACHPaypment from './payment/ach-payment';
import CreditCardForm from './payment/credit-card-payment';
import PayPalPayment from './payment/paypal-payment';
// import PaymentData from './payment/payment-data';
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";

class Payment extends Component {
  constructor() {
    super();
    this.state = {
      progress: 88.8,
      open: false,
      paymentType: '',
      paymentData: [],
      // paymentData: false,
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value }, console.log(this.state))

  getCookieValue = (name) => {
    var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

  selectType = (e) => {
    this.setState({ paymentType: e.target.getAttribute('name') }, console.log(this.state))
  }

  backToPaymentPage() {
    this.setState({paymentType:''})
  }

  onFinalSubmit = () => {
    this.props.storeProgressData("payment", "piece progress-green")
  }

  handleSkip = () => {
    this.props.storeProgressData("payment", "piece progress-gray")
  }


  onACHPaymentSubmit = (val) => {
    const { paymentData, fullName, bankName, accountNumber, bankRoutingNumber, bankLocation,paymentType } = this.state
    const payment = { fullName, bankName, accountNumber, bankRoutingNumber, bankLocation, paymentType }
    this.setState({ paymentData: [...paymentData, payment],
      fullName:'', bankName:'', accountNumber:'', bankRoutingNumber:'', bankLocation:''
     })
    
    // API.addACHPayment(
    //   this.state.email,
    //   this.state.type,
    //   this.state.fullName,
    //   this.state.bankName,
    //   this.state.accountNumber,
    //   this.state.bankCity,
    //   this.state.state,
    //   this.state.country
    // ).then(response => {
    //   return response.json()
    // }).then(responseData => {
    //   console.log(responseData);
    // }).catch(err => console.log('ERROR:', err))
  }

  onCreditCardFormSubmit = (val) => {
    const { paymentData, cardHolder, cardNumber, expDate, CVV, paymentType } = this.state
    const payment = { cardHolder, cardNumber, expDate, CVV, paymentType }
    this.setState({ paymentData: [...paymentData, payment],
      cardHolder:'', cardNumber:'', expDate:'', CVV:''
    }, console.log(this.state, 'ON SUBMIT FN'))

    // API.addCCPayment(
    //   this.state.email,
    //   this.state.type,
    //   this.state.fullName,
    //   this.state.bankName,
    //   this.state.accountNumber,
    //   this.state.bankCity,
    //   this.state.state,
    //   this.state.country
    // ).then(response => {
    //   return response.json()
    // }).then(responseData => {
    //   console.log(responseData);
    // }).catch(err => console.log('ERROR:', err))
  }

  render() {

    const { node, open, ach, creditCard, payPal } = this.state
    const style = {
      container: {
        borderRadius: 0,
      }
    }
// console.log(this.state, 'PARENT PAYMENT COMPONENT')
    return (
      <div>
        <ProgressBar progressData={this.props.progressData}/>
        {this.state.paymentType === '' ?
          <Segment padded='very' className="signup-form payment-container" raised>
            <Form onSubmit={this.handleSubmit}>
              <Header as='h1'>Payment Information</Header>
              <Container className="add-payment-container">
                <p className="add-payment" >
                  <Popup
                    // open={open}
                    trigger={<Icon onClick={this.toggle} name="add" circular color="blue" className="add-payment" size='big' />}
                    inverted
                    flowing hoverable size='tiny' position="top center" className="payment-popup" style={style.contiainer}
                  >
                    <Grid divided columns={1} className="payment-popup-grid">
                      <Grid.Column>
                        <Form.Group>
                          {/* <Link to='/paymentData' render={(props) => <ACHPaypment {...props} test="testValue" isAuthed={true} />}> */}
                          <p onClick={this.selectType.bind(this)} name="ACH INFORMATION" className="payment-popup-p"><Icon name="money bill alternate outline" />ACH</p>
                          {/* </Link> */}
                        </Form.Group>
                        <Form.Group>
                          {/* <Link> */}
                          <p onClick={this.selectType.bind(this)} name="CREDIT CARD" className="payment-popup-p"><Icon name="credit card outline" />Credit Card</p>
                          {/* </Link> */}
                        </Form.Group>
                        <Form.Group>
                          {/* <Link> */}
                          <p onClick={this.selectType.bind(this)} name="PAYPAL INFORMATION" className="payment-popup-p"><Icon name="cc paypal" />PayPal</p>
                          {/* </Link> */}
                        </Form.Group>
                      </Grid.Column>
                    </Grid>
                  </Popup>
                  {/* Add Payment Method */}
                </p>

              </Container>
            </Form>
            <div className="payment-buttonRow">
              <Link to='/powerOfAttorney'>
                <Button type='submit' className="payment-cancel">CANCEL</Button>
              </Link>
              <Link to='/addTeam'>
              <Button type='submit' className="payment-skip" onClick={this.handleSkip}>SKIP THIS</Button>
              </Link>
              <Link to='/addTeam'>
              <Button type='submit' className="payment-save" onClick={this.onFinalSubmit} color="twitter">SAVE & NEXT</Button>
              </Link> 
            </div>
          </Segment> :
          this.state.paymentType === 'ACH INFORMATION' ?
            <ACHPaypment backToPaymentPage={this.backToPaymentPage.bind(this)} open={this.state.paymentData} handleChange={this.handleChange.bind(this)} paymentData={this.state.paymentData} submit={this.onACHPaymentSubmit.bind(this)} count={this.state.paymentData.length} /> :
            this.state.paymentType === 'CREDIT CARD' ?
              <CreditCardForm backToPaymentPage={this.backToPaymentPage.bind(this)} open={this.state.paymentData} handleChange={this.handleChange.bind(this)} paymentData={this.state.paymentData} submit={this.onCreditCardFormSubmit.bind(this)} count={this.state.paymentData.length}/> :
              this.state.paymentType === 'PAYPAL INFORMATION' ?
                <PayPalPayment /> 
                :
                // this.state.paymentData === true ?
                //   <PaymentData />
                //   :
                  null}
      </div>
    );
  }
}

export default Payment;
